<template>
  <div>
    <user-profile-form
      @showResetPasswordModal="showResetPasswordModal"
      @showSetPasscodeModal="showSetPasscodeModal"
    ></user-profile-form>
    <user-profile-reset-password-modal
      :open.sync="showResetPasswordModalFlag"
      v-if="showResetPasswordModalFlag"
    ></user-profile-reset-password-modal>
    <user-profile-set-passcode-modal
      :open.sync="showSetPasscodeModalFlag"
      v-if="showSetPasscodeModalFlag"
    ></user-profile-set-passcode-modal>

  </div>
</template>

<script>

import UserProfileForm from '../../_components/profile/UserProfileForm'
const UserProfileResetPasswordModal = () => import('../../_components/profile/UserProfileResetPasswordModal')
const UserProfileSetPasscodeModal = () => import('../../_components/profile/UserProfileSetPasscodeModal')
export default {
  name: 'UserProfileDetailIndex',
  components: { UserProfileForm, UserProfileResetPasswordModal, UserProfileSetPasscodeModal },
  data () {
    return {
      showResetPasswordModalFlag: false,
      showSetPasscodeModalFlag: false
    }
  },
  methods: {
    showResetPasswordModal () {
      this.showResetPasswordModalFlag = true
    },
    showSetPasscodeModal () {
      this.showSetPasscodeModalFlag = true
    }
  }

}
</script>

<style>
</style>
